import cx from 'classnames';
import React, { ReactNode } from 'react';

import s from './toast-notification.module.css';

export interface ToastNotificationProps {
    children: ReactNode;
    type: 'success' | 'error';
    visible: boolean;
}

const ToastNotification = ({ children, type, visible, ...props }: ToastNotificationProps) => (
    <div className={cx(s.notification, s[type], visible ? s.enter : s.exit)} {...props}>
        {children}
    </div>
);

export default ToastNotification;
